import { TooltipIcon } from "components";
import { format } from "date-fns";

export function RemoveTimeFromDate(date: any) {
    if (!date) return "";
    let dateParts = date.split("T");
    return dateParts[0];
}

export function FormatDateToDMY(date: string) {
    if (!date) return "";
    if (date.includes("/")) return date;
    const dateParts = RemoveTimeFromDate(date).split("-");
    const day = dateParts[2];
    const month = dateParts[1];
    const year = dateParts[0];
    return `${day}/${month}/${year}`;
}
// date sample 2023-07-19T09:16:32 = 19/07/2023 09:16 
export function FormatDateToDMYH(date: string) {
    if (!date) return "";
    if (date.includes("/")) return date;
    const dateParts = RemoveTimeFromDate(date).split("-");
    const day = dateParts[2];
    const month = dateParts[1];
    const year = dateParts[0];
    const time = new Date(date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    return `${day}/${month}/${year} ${time}`;
}

export function FormatDateToDateTime(date: string) {
    if (!date) return "";
    const dateParts = date.split("/");
    const year = parseInt(dateParts[2]) + 2000;
    const month = parseInt(dateParts[1]) - 1;
    const day = parseInt(dateParts[0]);
    const newDate = new Date(year, month, day);
    return newDate.toISOString();
}

export function FormatDateToFileName(date: Date): string {
    return format(date, "dd-MM-yyyy_HH-mm-ss");
}

export function getOwnerNameById(id: string, ownersTable: Array<any>) {
    const owner: any = ownersTable.find((owner: any) => owner.id === id);
    return owner ? owner.name : "Owner not found";
}

// TODO: This is an N^2 loop!! We need to be caching the rows and doing a simple map or caching the ids and have it get updated when we remove/delete rows.
export function getRowIds(list: { position: number, id: number }[][]) {
    let rows: number[] = [];
    list.forEach((rowIndex) => rowIndex.forEach((row) => rows.push(row.id)));
    return rows;
}

export function calculateMarkup(basePrice: GLfloat, sellPrice: GLfloat) {
    let result: string | GLfloat = "";
    if (sellPrice !== 0 && basePrice !== 0) {
        let markup = (sellPrice - basePrice) / basePrice * 100;
        if (!isNaN(markup) && isFinite(markup)) {
            result = `${markup.toFixed(2)}%`;
        }
    }
    return result;
}

export function calculateGP(sellPrice: GLfloat, costEx: GLfloat, gstCode: string, ) {
    let salesEx = sellPrice / (gstCode === "Y" ? 1.1 : 1);
    let gp = (salesEx - costEx) / salesEx * 100;
    if (!isNaN(gp) && Number.isFinite(gp)) {
        return gp.toFixed(2);
    } else {
        return undefined;
    }
}

// Takes the row value from a table and parses it to a float with 2 decimal places
export function displayFloatPrice(value: string) {
    if (!value) return;
    const floatValue = parseFloat(value);
    const formattedValue = floatValue.formatAsPrice();
    return <span>{floatValue !== 0 ? `$${formattedValue}` : null}</span>;
}
// Displays a tooltip icon based on the text passed in
export function displayTooltipsIcons(text: string) {
    if (text === "Mixed") return <TooltipIcon text="Contains a mixed level of price groups" placement="right" />
    if (text === "Base Sell Price") return <TooltipIcon text="Sell price set against the stock card when no Price Group is assigned" placement="right" />
}

export function ValidateInt(value: any, min: number | undefined = undefined, max: number | undefined = undefined): boolean {
    let number = parseInt(value);
    if (Number.isNaN(number) || (min !== undefined && number < min) || (max !== undefined && number > max)) {
        return false;
    } else {
        return true;
    }
}

export function ParseAndValidateFloat(value: any, min: number | undefined = undefined, max: number | undefined = undefined): {output: boolean, value: number} {
    if (value && value.includes("$")) value = value.replace("$", "");
    let number = parseFloat(value);
    if (Number.isNaN(number) || (min !== undefined && number < min) || (max !== undefined && number > max)) {
        return {output: false, value: number};
    } else {
        return {output: true, value: number};
    }
}

export function convertToFloat(value: any){
    if (value.includes("$")) value = value.replace("$", "");
    let number = parseFloat(value);
    if (Number.isNaN(number)) {
        return 0;
    } else {
        return number;
    }
}

export function ToFixedNotRounded(num: number, fixed: number): string | number {
    var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
    var match = num.toString().match(re);
    return match !== null && match.length > 0 ? parseFloat(match[0]).toFixed(fixed) : Number.NaN;
}


export function ValidateBoolean(value: any): { valid: boolean, newValue: any } {
    if (value === undefined || value === "" || value === null) {
        return ({ valid: false, newValue: undefined });
    } else if (value === 1 || value === "1" || value.toLocaleLowerCase() === "true" || value.toLocaleLowerCase() === "yes" || value.toLocaleLowerCase() === "y") {
        return ({ valid: true, newValue: "true" });
    } else if (value === 0 || value === "0" || value.toLocaleLowerCase() === "false" || value.toLocaleLowerCase() === "no" || value.toLocaleLowerCase() === "n") {
        return ({ valid: true, newValue: "false" });
    } else {
        return ({ valid: false, newValue: undefined });
    }
}